<template>
    <div class="body">
        <mslNav></mslNav>
        <!-- 产品轮播图 -->
        <div class="swiper">
            <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
                <van-swipe-item v-for="(item, index) in detail.slider_image_list" :key="index">
                    <div class="img_box">
                        <img :src="item" alt="">
                    </div>
                </van-swipe-item>
            </van-swipe>
        </div>
        <!-- 产品资料 -->
        <div class="pro_detail">
            <div class="title ta_center">{{ detail.store_name || '' }}</div>
            <div class="price ta_center">{{ '￥' + (detail.price || '') }}</div>
            <div class="intro ta_center">{{ detail.store_info || '' }}</div>
            <div class="code_box ta_center" v-if="detail.qr_code">
                <img class="qr_code" :src="detail.qr_code" alt="">
                <div class="name ta_center">手机微信扫码购买</div>
            </div>
        </div>
        <!-- 产品参数， 特征， 特点 -->
<!--        <div class="pro_parm">-->
<!--            <van-collapse v-model="activeNames" accordion>-->
<!--                <van-collapse-item title="产品参数" name="1">-->
<!--                    <div class="content">-->
<!--                        <div class="c_item" v-for="(item, index) in 4" :key="index">-->
<!--                            <div class="ci_title ta_left">MANSUL型号</div>-->
<!--                            <div class="ci_content ta_left">OSS-100-200（ZYA）</div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </van-collapse-item>-->
<!--                <van-collapse-item title="产品特征" name="2">-->
<!--                    <div class="content">-->
<!--                        <div class="c_item" v-for="(item, index) in 4" :key="index">-->
<!--                            <div class="ci_title ta_left">MANSUL型号</div>-->
<!--                            <div class="ci_content ta_left">OSS-100-200（ZYA）</div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </van-collapse-item>-->
<!--                <van-collapse-item title="产品特点" name="3">-->
<!--                    <div class="content">-->
<!--                        <div class="c_item" v-for="(item, index) in 4" :key="index">-->
<!--                            <div class="ci_title ta_left">MANSUL型号</div>-->
<!--                            <div class="ci_content ta_left">OSS-100-200（ZYA）</div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </van-collapse-item>-->
<!--            </van-collapse>-->
<!--        </div>-->
        <!-- 产品详情 -->
        <div class="detail_img">
            <div class="title_box row_center">
                <div class="line"></div>
                <div class="title">产品描述</div>
                <div class="line"></div>
            </div>
            <div class="pro_img" v-html="detail.description"></div>
        </div>
        <!-- 在线咨询 -->
        <div class="back row_center">
            <onlineBtn></onlineBtn>
        </div>
        <!-- 底部 -->
        <mslFooter></mslFooter>
    </div>
</template>

<script>
    import onlineBtn from '../components/onlineBtn'
    import { proDetail } from "../api/common";
    export default {
        name: "production_detail",
        components: {
            onlineBtn
        },
        data() {
            return {
                activeNames: '1',
                id: null,
                detail: {},
            }
        },
        mounted() {
            this.getParams();
        },
        methods: {
            getParams(){
                this.id = this.$route.query.id; // 取到路由带过来的参数
                this.getDetail();
                window.scrollTo(0, 0);//回到顶部
            },
            // 商品详情
            getDetail() {
                try {
                    console.log('测试1');
                    proDetail({
                        id: this.id
                    }).then((res) => {
                        if (res.code == 1) {
                            if (res.data && res.data.id) {
                                this.detail = res.data;
                                console.log(this.detail, 'detail');
                            }
                        }
                    })
                } catch {
                    console.log('测试2');
                    this.$message.error('获取数据失败，请刷新');
                }
            }
        }

    }
</script>

<style scoped lang="scss">
    .body {
        /* 产品轮播图 */
        .swiper {
            width: 100%;
            height: 375px;
            .my-swipe {
                width: 100%;
                height: 375px;
                .van-swipe-item {
                    width: 100%;
                    height: 375px;
                    .img_box {
                        width: 100%;
                        height: 375px;
                        overflow: hidden;
                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
            }
        }

        /* 在线咨询 */
        .back {
            width: 100%;
            padding: 24px 0;
            box-sizing: border-box;
            .ask {
                width: 89px;
                height: 34px;
                border: 1px solid #262626;
                border-radius: 2px;
                margin-right: 20px;
                font-size: 14px;
                font-family: Alibaba PuHuiTi;
                font-weight: 400;
                line-height: 20px;
                color: #262626;
            }
        }

        /* 产品资料 */
        .pro_detail {
            padding: 24px 16px;
            .title {
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: bold;
                line-height: 22px;
                color: #333333;
            }
            .price {
                font-size: 16px;
                font-family: SF Pro Display;
                font-weight: 800;
                line-height: 19px;
                color: #262626;
                margin-top: 8px;
            }
            .intro {
                margin-top: 12px;
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 500;
                line-height: 21px;
                color: #8C8C8C;
            }
            .code_box {
                margin-top: 24px;
                .qr_code {
                    width: 120px;
                    height: 120px;
                }
                .name {
                    font-size: 14px;
                    line-height: 21px;
                    color: #8C8C8C;
                    margin-top: 12px;
                }
            }
        }

        /* 产品参数，特征，特点 */
        .pro_parm {
            box-sizing: border-box;
            background-color: #f5f5f5;
            &::v-deep {
                .van-hairline--top-bottom {
                    border-width: 0px;
                }
                .van-collapse-item--border {
                    &::after {
                        border-top: 0;
                    }
                }
                .van-collapse-item__content {
                    background-color: #f5f5f5;
                }
                .van-cell {
                    background-color: #f5f5f5;
                    box-sizing: border-box;
                    padding: 16px;
                    .van-cell__title {
                        text-align: left;
                        font-size: 16px;
                        font-family: PingFang SC;
                        font-weight: bold;
                        line-height: 22px;
                        color: #262626;
                    }
                    &::after {
                        border-bottom: 0px;
                    }
                    .van-cell__right-icon {
                        color: #262626;
                        font-size: 20px;
                    }


                }
            }
            .content {
                .c_item {
                    padding: 16px 0;
                    box-sizing: border-box;
                    border-bottom: 1px solid rgba(217, 217, 217, .4);
                    &:last-child {
                        border-bottom: 0;
                    }
                    .ci_title {
                        font-size: 12px;
                        font-family: PingFang SC;
                        font-weight: 500;
                        line-height: 21px;
                        color: #8C8C8C;
                        opacity: 1;
                    }
                    .ci_content {
                        margin-top: 4px;
                        font-size: 14px;
                        font-family: SF Pro Display;
                        font-weight: 400;
                        line-height: 21px;
                        color: #262626;
                        opacity: 1;
                    }
                }
            }


        }

        /* 产品详情 */
        .detail_img {
            width:100%;

            .title_box {
                padding: 16px;
                box-sizing: border-box;
                .line {
                    width:80px;
                    height:1px;
                    background-color: #ddd;
                }

                .title {
                    font-size:14px;
                    color: #8c8c8c;
                    margin: 0 12px;
                }
            }

            .pro_img {
                width: 100%;
                &::v-deep {
                    img {
                        width:100%!important;
                    }
                    p {
                        margin: 0!important;
                        padding: 0!important;
                        margin-block-start: 0!important;
                        margin-block-end: 0!important;
                        display: inline-block!important;
                    }
                }
            }




        }
    }

</style>
